import { RogersBankConfigService, rogersBankRoutes } from '@rogers/self-serve-rogers-bank';
import { RogersBankService } from './rogers-bank.service';
import { rogersBankConfigFactory } from './rogers-bank.config';
import { ROGERS_BANK_ROUTE } from '@rci/self-serve-fido/app.constant';
import { EnsureNoGlobalApiErrorGuard } from '@rci/self-serve-fido/shared/error/ensure-no-global-api-error.guard';
import { RogerBankBlankAppGuard } from './blank-app/rogers-bank-blank-app.guard';
import { ApiEndpointService } from '@rci/self-serve-shared';

export const rogersBankAppRoutes = [
  {
    path: ROGERS_BANK_ROUTE,
    canActivate: [RogerBankBlankAppGuard, EnsureNoGlobalApiErrorGuard],
    children: [...rogersBankRoutes],
    providers: [
      RogersBankService,
      {
        provide: RogersBankConfigService,
        useFactory: rogersBankConfigFactory,
        deps: [RogersBankService, ApiEndpointService],
      },
    ],
  },
];
